function createConfig() {
  let lang = 'en';

  function setLang() {
    lang = lang;
  }

  return { lang, setLang };
}

const config = createConfig();

export default config;
